import type { SegmentationKey } from 'lumen/models/parity/insight/segmentation-item';
import {
  LIMITED_CONCURRENT_BREAKDOWNS,
  SINGLE_SELECT_BREAKDOWNS,
} from 'lumen/utils/constants/pi-constant-values';

const MAX_CONCURRENT_SELECTIONS = 15;

// Checks if a SINGLE_SELECT_BREAKDOWNS filter is already selected (max 1 filter)
export function limitReached(
  currentFilters: Record<string, string[]>,
  requestedSegmentation: SegmentationKey,
): boolean {
  if (
    SINGLE_SELECT_BREAKDOWNS.some(
      (breakdown) => breakdown === requestedSegmentation,
    ) &&
    currentFilters[requestedSegmentation]
  ) {
    const currentFilter = currentFilters[requestedSegmentation];
    return currentFilter.length >= 1;
  }

  return false;
}

// Checks max concurrency for LIMITED_CONCURRENT_BREAKDOWNS
function maxConcurrencyReached(
  currentFilters: Record<string, string[]>,
  requestedSegmentation: SegmentationKey,
): boolean {
  // Only prevent the selection when it's one of the LIMITED_CONCURRENT_BREAKDOWNS
  if (
    LIMITED_CONCURRENT_BREAKDOWNS.some(
      (breakdown) => breakdown === requestedSegmentation,
    )
  ) {
    let concurrentFilters = 0;
    // Sum the total active selections for LIMITED_CONCURRENT_BREAKDOWNS
    LIMITED_CONCURRENT_BREAKDOWNS.forEach((segmentation) => {
      if (currentFilters[segmentation]) {
        concurrentFilters += currentFilters[segmentation].length;
      }
    });

    return concurrentFilters >= MAX_CONCURRENT_SELECTIONS;
  }

  return false;
}

// Combines the conditions above to check if you can add a filter at all
export function canAddParityFilter(
  currentFilters: Record<string, string[]>,
  breakdown: SegmentationKey,
): boolean {
  const isLimitReached = limitReached(currentFilters, breakdown);
  const isMaxConcurrencyReached = maxConcurrencyReached(
    currentFilters,
    breakdown,
  );
  return !isLimitReached && !isMaxConcurrencyReached;
}
